customElements.get("media-gallery-mobile") || 
customElements.define("media-gallery-mobile", class extends HTMLElement {
  constructor() {
    super();
    
    this.selectors = {
      container: ".m-main-product--wrapper",
      slider: ".swiper-container",
      sliderPagination: ".swiper-pagination",
      sliderPrevEl: ".swiper-button-prev",
      sliderNextEl: ".swiper-button-next",
      navSlider: ".nav-swiper-container",
      medias: [".m-product-media--item"],
      mediaWrapper: ".m-product-media--wrapper",
      mediaZoomIns: [".m-product-media__zoom-in"],
      videos: [".media-video"],
      variantIdNode: '[name="id"]',
      featuredImage: ".m-product-media"
    };
    
    this.container = this.closest(this.selectors.container);
    this.domNodes = queryDomNodes(this.selectors, this);
    this.enableVideoAutoplay = "true" === this.dataset.enableVideoAutoplay;
    this.enableImageZoom = "true" === this.dataset.enableImageZoom;
    this.enableVariantGroupImages = "true" === this.dataset.enableVariantGroupImages;
    this.onlyMedia = "true" === this.dataset.onlyMedia;
    
    if (this.container) {
      this.view = this.container.dataset.view || "product-template";
    }
    
    this.section = this.closest(`[data-section-id="${this.sectionId}"]`);
    this.layout = this.dataset.layout;
  }

  connectedCallback() {
    this.setupData();
  }

  async setupData() {
    this.productHandle = this.dataset.productHandle;
    this.productUrl = this.dataset.productUrl;
    this.productData = await this.getProductJson(this.productUrl);
    
    const { productData: productData, productData: { variants: variants } = {} } = this;
    const variantIdNode = this.container.querySelector(this.selectors.variantIdNode);
    
    if (productData && variantIdNode) {
      let variantId = Number(variantIdNode.value);
      if (!variantId) {
        variantId = productData.selected_or_first_available_variant.id;
      }
      
      const initialVariant = variants.find((variant) => variant.id === variantId) || variants[0];
      this.productData.initialVariant = initialVariant;
      
      if (!this.productData.selected_variant && variantIdNode.dataset.selectedVariant) {
        this.productData.selected_variant = variants.find((variant) => variant.id === Number(variantIdNode.dataset.selectedVariant));
      }
      
      this.init();
    }
  }

  init() {
    const variantPicker = this.container.querySelector("variant-picker");
    
    this.handlePhotoswipe();
    this.initPhotoswipe();
    this.initSlider();
    this.handleAutoplayVideo();
    
    if (!variantPicker) {
      this.initPhotoswipe();
      this.handleSlideChange();
      this.removeAttribute("data-media-loading");
      this.firstElementChild.style.opacity = 1;
    }
  }

  initSlider() {
    if (!this.domNodes.slider) return;
    
    this.mediaMode = "slider";
    const { domNodes: { slider, sliderPagination, navSlider, sliderNextEl, sliderPrevEl } } = this;
    
    let initialSlide = 0;
    let navSliderOptions = {};
    let mainSliderOptions = {};
    
    if (this.productData.initialVariant && this.productData.selected_variant && this.productData.initialVariant.featured_media) {
      initialSlide = this.productData.initialVariant.featured_media.position - 1 || 0;
    }
    
    navSliderOptions = {
      loop: false,
      initialSlide: initialSlide,
      slidesPerView: 4.5,
      freeMode: true,
      spaceBetween: 8,
      threshold: 2,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      on: {
        init: () => {
          navSlider.style.opacity = 1;
        }
      }
    };
    
    this.navSlider = navSlider ? new MinimogLibs.Swiper(navSlider, navSliderOptions) : null;
    
    const thumbsOptions = this.navSlider ? { thumbs: { swiper: this.navSlider } } : {};
    
    mainSliderOptions = {
      initialSlide: initialSlide,
      autoHeight: true,
      navigation: {
        nextEl: sliderNextEl,
        prevEl: sliderPrevEl
      },
      threshold: 2,
      loop: !this.enableVariantGroupImages,
      pagination: {
        el: sliderPagination,
        clickable: true,
        type: "bullets"
      },
      // Add peeking effect for mobile devices
      slidesPerView: 1.2,
      spaceBetween: 16,
      // Responsive breakpoints
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 0
        }
      },
      ...thumbsOptions,
      on: {
        init: () => {
          slider.style.opacity = 1;
          this.domNodes = queryDomNodes(this.selectors, this.container);
        }
      }
    };
    
    this.slider = new MinimogLibs.Swiper(slider, mainSliderOptions);
    
    if (!this.enableVariantGroupImages) {
      this.handleSlideChange();
    }
  }

  handleSlideChange() {
    if (!this.slider) return;
    
    let allowTouchMove = true;
    let mediaType = "";
    let slideIndexes = [];
    
    this.slider.on("slideChange", (swiper) => {
      window.pauseAllMedia(this);
      
      try {
        const { slides, activeIndex } = swiper;
        if (slides[activeIndex]) {
          this.playActiveMedia(slides[activeIndex]);
        }
        
        slideIndexes = [activeIndex];
        
        for (let index of slideIndexes) {
          const slide = slides[index];
          if (slide) {
            mediaType = slide.dataset.mediaType;
            if (mediaType === "model") break;
          }
        }
        
        if (mediaType === "model") {
          this.slider.allowTouchMove = false;
          allowTouchMove = false;
        } else {
          if (!allowTouchMove) {
            this.slider.allowTouchMove = true;
          }
          allowTouchMove = true;
        }
      } catch (error) {
        // Handle error
      }
    });
  }

  handleAutoplayVideo() {
    if (this.slider) {
      const { slides, activeIndex } = this.slider;
      const activeSlide = slides[activeIndex];
      const mediaType = activeSlide && activeSlide.dataset.mediaType;
      
      if (mediaType === "video" || mediaType === "external_video") {
        const deferredMedia = activeSlide.querySelector("deferred-media");
        const autoPlay = "true" === deferredMedia.dataset.autoPlay;
        
        if (deferredMedia && autoPlay) {
          deferredMedia.loadContent(false);
        }
      }
    } else {
      const mediaItems = this.querySelectorAll(".m-product-media--item");
      
      if (mediaItems) {
        mediaItems.forEach((item) => {
          const mediaType = item.dataset.mediaType;
          
          if (mediaType === "video" || mediaType === "external_video") {
            const deferredMedia = item.querySelector("deferred-media");
            const autoPlay = "true" === deferredMedia.dataset.autoPlay;
            
            if (deferredMedia && autoPlay) {
              deferredMedia.loadContent(false);
            }
          }
        });
      }
    }
  }

  playActiveMedia(slide) {
    const deferredMedia = slide.querySelector("deferred-media");
    if (!deferredMedia) return;
    
    if ("true" === deferredMedia.dataset.autoPlay) {
      if (deferredMedia.getAttribute("loaded")) {
        const mediaElement = deferredMedia.querySelector("video, model-viewer, iframe");
        
        if (mediaElement.classList.contains("js-youtube")) {
          const separator = mediaElement.src.indexOf("?") > -1 ? "&" : "?";
          mediaElement.src += separator + "autoplay=1&mute=1";
        } else if (mediaElement.classList.contains("js-vimeo")) {
          const separator = mediaElement.src.indexOf("?") > -1 ? "&" : "?";
          mediaElement.src += separator + "autoplay=1&muted=1";
        } else {
          mediaElement.play();
        }
      } else {
        deferredMedia.loadContent(false);
        const mediaElement = deferredMedia.querySelector("video, model-viewer, iframe");
        
        if (mediaElement.classList.contains("js-youtube")) {
          const separator = mediaElement.src.indexOf("?") > -1 ? "&" : "?";
          mediaElement.src += separator + "autoplay=1&mute=1";
        } else if (mediaElement.classList.contains("js-vimeo")) {
          const separator = mediaElement.src.indexOf("?") > -1 ? "&" : "?";
          mediaElement.src += separator + "autoplay=1&muted=1";
        } else {
          mediaElement.play();
        }
      }
    }
  }

  handlePhotoswipe(dataSource = []) {
    if (!this.enableImageZoom) return;
    
    const items = [];
    const mediaItems = this.querySelectorAll(".m-product-media--item:not(.swiper-slide-duplicate)");
    
    if (mediaItems) {
      mediaItems.forEach((item, index) => {
        if (item.dataset.mediaType === "image") {
          const mediaData = item.querySelector(".m-product-media").dataset;
          items.push({
            src: mediaData.mediaSrc,
            width: parseInt(mediaData.mediaWidth),
            height: parseInt(mediaData.mediaHeight),
            alt: mediaData.mediaAlt,
            id: item.dataset.index
          });
        } else {
          items.push({
            html: `<div class="pswp__${item.dataset.mediaType}">${item.innerHTML}</div>`,
            type: item.dataset.mediaType,
            id: item.dataset.index
          });
        }
      });
    }
    
    this.lightbox = new MinimogLibs.PhotoSwipeLightbox({
      dataSource: dataSource.length > 0 ? dataSource : items,
      bgOpacity: 1,
      close: false,
      zoom: false,
      arrowNext: false,
      arrowPrev: false,
      counter: false,
      preloader: false,
      pswpModule: MinimogLibs.PhotoSwipeLightbox.PhotoSwipe
    });
    
    this.lightbox.addFilter("thumbEl", (thumbEl, item, index) => {
      const img = this.querySelector(`[data-index="${item.id}"]:not(.swiper-slide-duplicate) img`);
      return img || thumbEl;
    });
    
    this.lightbox.addFilter("placeholderSrc", (placeholderSrc, item) => {
      const img = this.querySelector(`[data-index="${item.data.id}"]:not(.swiper-slide-duplicate) img`);
      return img ? img.src : placeholderSrc;
    });
    
    this.lightbox.on("change", () => {
      window.pauseAllMedia(this);
      
      if (this.slider) {
        const index = this.lightbox.pswp.currIndex;
        if (this.enableVariantGroupImages) {
          this.slider.slideTo(index, 100, false);
        } else {
          this.slider.slideToLoop(index, 100, false);
        }
      }
    });
    
    this.lightbox.on("pointerDown", (event) => {
      if (this.lightbox.pswp.currSlide.data.type === "model") {
        event.preventDefault();
      }
    });
    
    const closeButton = {
      name: "m-close",
      order: 11,
      isButton: true,
      html: '<svg class="m-svg-icon--large" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>',
      onClick: (event, element, lightbox) => {
        lightbox.close();
      }
    };
    
    const nextButton = {
      name: "m-arrowNext",
      className: "sf-pswp-button--arrow-next",
      order: 12,
      isButton: true,
      html: '<svg fill="currentColor" width="14px" height="14px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"></path></svg>',
      onClick: (event, element, lightbox) => {
        lightbox.next();
      }
    };
    
    const prevButton = {
      name: "m-arrowPrev",
      className: "sf-pswp-button--arrow-prev",
      order: 10,
      isButton: true,
      html: '<svg width="14px" height="14px" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z"></path></svg>',
      onClick: (event, element, lightbox) => {
        lightbox.prev();
      }
    };
    
    this.lightbox.on("uiRegister", () => {
      this.lightbox.pswp.ui.registerElement(closeButton);
      
      if (!this.onlyMedia) {
        this.lightbox.pswp.ui.registerElement(prevButton);
        this.lightbox.pswp.ui.registerElement(nextButton);
      }
    });
  }

  initPhotoswipe() {
    if (this.enableImageZoom) {
      this.lightbox.init();
      
      addEventDelegate({
        selector: this.selectors.medias[0],
        context: this,
        handler: (event, target) => {
          event.preventDefault();
          
          const isImage = target.classList.contains("media-type-image");
          const isZoomButton = event.target.closest(this.selectors.mediaZoomIns[0]);
          
          if (isImage || isZoomButton) {
            const index = Number(target.dataset.index) || 0;
            this.lightbox.loadAndOpen(index);
          }
        }
      });
    }
  }

  setActiveMedia(variant) {
    if (variant && variant.featured_media) {
      const position = variant.featured_media.position || 0;
      
      if (this.slider && this.slider.wrapperEl) {
        this.slider.slideToLoop(position - 1);
      }
    }
  }

  scrollIntoView(element) {
    element.scrollIntoView({ behavior: "smooth" });
  }

  getProductJson(url) {
    return fetch(url + ".js")
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        return JSON.parse(this.container.querySelector("#productData[type='application/json']").textContent);
      })
      .catch((error) => {
        // Handle error
      });
  }
});